import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';

// services
import { BasicObservableService } from './basic-observable.service';

@NgModule({
  imports: [CommonModule],
})
export class BasicObservableModule {
  static forRoot(): ModuleWithProviders<BasicObservableModule> {
    return {
      ngModule: BasicObservableModule,
      providers: [BasicObservableService],
    };
  }
}
